import React from 'react'
import { Container, Label, SourceList } from './Source.styles'
import { SourceProps } from './Source.types'

export const Source: React.FC<SourceProps> = ({
  sources,
  label = 'Sources:',
  separator = ' • ',
  size = 'small',
  className,
  style,
  children,
  showLabel = true,
  'aria-label': ariaLabel,
}) => {
  const sourceText = sources.join(separator)

  return (
    <Container
      className={className}
      style={style}
      $size={size}
      aria-label={ariaLabel || `Data sources: ${sourceText}`}
      role="contentinfo"
    >
      {showLabel && <Label>{label}</Label>}
      <SourceList>{(children || sourceText) as any}</SourceList>
    </Container>
  )
}
